import HeadingHeroTitle from "./HeadingHeroTitle"
import HeadingModalTitle from "./HeadingModalTitle"
import HeadingPageTitle from "./HeadingPageTitle"
import HeadingSectionHeader from "./HeadingSectionHeader"
import HeadingSubSectionHeader from "./HeadingSubSectionHeader"

const Heading = {
  HeroTitle: HeadingHeroTitle,
  PageTitle: HeadingPageTitle,
  ModalTitle: HeadingModalTitle,
  SectionHeader: HeadingSectionHeader,
  SubSectionHeader: HeadingSubSectionHeader,
}

export default Heading
